
export const addLoarder = () => {
    let body = document.querySelector("body");
    body.classList.add("overflow");
    let loader = document.querySelector(".loader");
    loader.classList.add("show");
    loader.classList.remove("hide");
}

export const removeLoader = () => {
    let body = document.querySelector("body");
    body.classList.remove("overflow");
    let loader = document.querySelector(".loader");
    loader.classList.add("hide");
}

